interface routerProps {
  push: (x: string) => void
}
const goToFederateAuthURL = (router: routerProps) => {
  const onClickPromoTag = ({
    name,
    filterId,
    description,
  }: {
    name: string
    filterId: string
    description: string
  }) =>
    router.push(
      `/tagFilter?name=${name}&filterId=${filterId}&description=${description}`
    )

  return onClickPromoTag
}

export default goToFederateAuthURL
